import React from "react";
import { View, Text, StyleSheet, TouchableOpacity,
	Platform, Dimensions, Image, ImageBackground, AsyncStorage, FlatList } from "react-native";
	
import * as firebase from "firebase";
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import BranchModel from "../models/BranchModel";
import PlaceholderComp from "../utilities/PlaceholderComp";

import TopBar from "../widgets/TopBar";
import Main from "../widgets/Main";
import Menu from "../widgets/Menu";
import MainComponent from '../utilities/MainComponent';
import i18n from 'i18n-js';

export default class BranchesScreen extends MainComponent {	
	
	static path = ''
	state = {
		title: "Branches",
		topBarData:{title: "Branches", isScrollable: false},
		showMenu 		: false,
		showFullMode 	: true,
		data : [],
		fakeData : new Array(10).fill({})
	};
	
	static navigationOptions = {
		headerShown: false
	};

	changeState(states){
		if(states.openOrder != undefined && states.openOrder == true)
			this.reviewOrder()
		else
			this.setState(states)
	}

	constructor(props) {
		super(props);

		this.changeState = this.changeState.bind(this)

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		this.state.height = screenHeight
		this.state.width = screenWidth
				
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
		this.updateCart()
	}

	updateCart = async () => {
		
		try {
			var selectedIds = []
			//await AsyncStorage.clear()
			var value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
				value = JSON.parse(value)			
			
			if(value.length > 0){
				var totalPrice = 0
				value.map(item => {
					totalPrice += item.price
					item.addons.map(addon => {
						addon.modifiers.map(modifier => {
							totalPrice += modifier.price
						})
					})
					selectedIds[item.itemId] = item.counter
				})

				this.setState({showCart: true, totalPrice: totalPrice, orderCount: value.length, selectedIds: selectedIds})
			}

			var value = await AsyncStorage.getItem(store.delivery)
			if (value == undefined)
				value = {name: ""}
			else
				this.setState({deliveryData: JSON.parse(value)})

		} catch (error) {
			console.log(error)
		}
	}

	reviewOrder(){

		if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
			 || this.state.deliveryData.area === {} || this.state.deliveryData.area == ''){
			this.props.navigation.navigate("menu");
			return
		}

		if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
			|| this.state.deliveryData.timings === {} || this.state.deliveryData.timings == ''){
			this.props.navigation.navigate("menu");
		   return
	   }
		
	   this.props.navigation.navigate("review");
	}

	getDetails = async () => {		

		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})

			

        } catch (error) {
            console.log(error)
        }

		var that = this
		firebase.database().ref('stores/' + store.storeId + "/branches/").once("value", function(snapshot) {			
			
			var data = []
			let mDat = snapshot.val()
			mDat.map(obj => {
				let category = new BranchModel()
				category.name = obj.name
				category.nameSecondary = obj.nameSecondary
				category.details = obj.details
				category.lat = obj.lat
				category.lng = obj.lng
				category.coords = obj.coords
				category.address = obj.address
				category.timings = obj.timings
				category.addressSecondary = obj.addressSecondary
				data.push(category)		
			});

			that.setState({data: data})
		}.bind(this), function(error) { 
			console.log(error)
		});

		await Font.loadAsync(color.appFonts);
	}

	listRowPressed(item, index){
		this.props.navigation.navigate('branchDetails', {
			branch: index,
		});
	}

	openMenu(){
		this.setState({showMenu: true});
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	// List View 
	renderDetails(marginTop){
		return (
			<View style={styles.container}>
								
				{this.state.data.length > 0 && (
					<FlatList
						style={{marginTop: marginTop}}
						showsHorizontalScrollIndicator={false}
						data={this.state.data}
						renderItem={this.renderListItem}
						keyExtractor={item => item.name}
					/>
				)}
				{this.state.data.length == 0 && (
					this.state.fakeData.map((e, i) => <PlaceholderComp key={i} />)
				)}

			</View>
		)
	}

	renderListItem = ({ item, index }) => 
	{		
		var name = item.name
		var address = item.address

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.nameSecondary
            address    = item.addressSecondary
        }
        if(name == undefined || name == "")
			name = item.name
		if(address == undefined || address == "")
			address = item.address

		return (
			<TouchableOpacity 
				onPress={() => this.listRowPressed(item, index)}
			>
				<View  style={{height: 95, borderBottomWidth: 1, borderBottomColor: color.menuUnselected}}>
					<View style={{height: 1, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
					<View  style={{ flexDirection: "row", height: 94, justifyContent: "center", alignContent: "center", alignItems:"center"}}>
							<View style={{marginLeft: 15}}>
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 16 }}>{name}</Text>
								<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginTop: 5 }}>{address}</Text>
							</View>
							<Ionicons style={{marginLeft: "auto", marginRight: 15}} name="ios-information-circle-outline"  color={this.state.store.primaryColor} size={20} />			
					</View>
				</View>
			</TouchableOpacity>
		  );
	}
	
	render() {
		var that = this
		return (
			<View style={styles.container}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{height: this.state.height, width: this.state.width * .33}}>
	                        {this.renderDetails(50)}
							<TopBar {...this.state} changeState={this.changeState} />
						</View>	

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{height: this.state.height}}>
	                        {that.renderDetails(50)}
						</View>	
						<TopBar {...this.state} changeState={this.changeState} />

					</View>
				)}

				{!this.state.showFullMode && this.state.showMenu && (					
					<View style={styles.container}>						

						<Menu {...this.state} changeState={this.changeState} />
						
					</View>
				)}	
				
			</View>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	}
});